export function renderPanelHeader(title: string, rightLabel: string = ''): string {
    return `
      <div class="terminal-panel__header">
        <h3 class="terminal-panel__title">${title}</h3>
        ${rightLabel ? `<span class="terminal-panel__meta">${rightLabel}</span>` : ''}
      </div>
    `;
}

export function renderPanelTabs(tabs: string[], activeTab: string): string {
    const items = tabs.map(tab => {
        const activeClass = tab === activeTab ? ' terminal-panel__tab--active' : '';
        return `<button class="terminal-panel__tab${activeClass}" type="button" data-tab="${tab}">${tab}</button>`;
    }).join('');

    return `<div class="terminal-panel__tabs">${items}</div>`;
}

export function renderStatStrip(stats: Array<{ label: string; value: string; tone?: 'up' | 'down' | 'neutral' }>): string {
    const nodes = stats.map(stat => {
        const toneClass = stat.tone ? ` terminal-stat--${stat.tone}` : '';
        return `
          <div class="terminal-stat${toneClass}">
            <span class="terminal-stat__label">${stat.label}</span>
            <span class="terminal-stat__value">${stat.value}</span>
          </div>
        `;
    }).join('');

    return `<div class="terminal-stat-strip">${nodes}</div>`;
}
